import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { logger } from '@/application/core';
import { NS } from './namespaces';

// Window augmentations consolidated in types/global.d.ts

// Get common namespace translations embedded by _Layout.cshtml
const currentCulture = window.appCulture || 'en-US';
const commonTranslations = window.appTranslations || {};

// Initialize i18next with embedded common namespace + lazy-loaded feature namespaces
i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    // Only common namespace is embedded — feature namespaces are lazy-loaded via HttpBackend
    resources: {
      [currentCulture]: {
        common: commonTranslations,
      },
    },

    lng: currentCulture,
    fallbackLng: 'en-US',
    load: 'currentOnly', // Only load exact culture code (e.g. 'vi-VN'), skip 'vi' short code

    // defaultNS is 'common' — bare t('Key') resolves from common namespace
    ns: [NS.COMMON],
    defaultNS: NS.COMMON,
    fallbackNS: NS.COMMON,

    // HttpBackend fetches feature namespaces on demand (developer-plan, manage-subscription, etc.)
    backend: {
      loadPath: '/api/v1/translations/{{lng}}/{{ns}}',
    },

    // partialBundledLanguages: common is pre-loaded, feature namespaces fetched via HTTP
    partialBundledLanguages: true,

    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    debug: false,

    react: {
      useSuspense: true,
    },
  });

// --- i18n load diagnostics ---
i18n.on('initialized', () => {
  const embeddedKeyCount = Object.keys(commonTranslations).length;
  logger.info('i18n', `Ready | culture: ${currentCulture} | common keys: ${embeddedKeyCount}`);
});

i18n.on('loaded', (loaded) => {
  // loaded = { 'en-US': { 'developer-plan': true } }
  Object.entries(loaded).forEach(([lng, namespaces]) => {
    Object.keys(namespaces as object).forEach((ns) => {
      logger.info('i18n', `Loaded namespace via API | ${lng}/${ns}`);
    });
  });
});

i18n.on('failedLoading', (lng, ns, msg) => {
  logger.error('i18n', `Failed to load namespace | ${lng}/${ns}: ${msg}`);
});

i18n.on('missingKey', (_lngs, ns, key) => {
  logger.warn('i18n', `Missing key | [${ns}] ${key}`);
});

export default i18n;
